<template>
  <div class="vid-switcher">
    <div class="title">
      <p class="graph-copy black" v-html="this.data.title"></p>
    </div>
    <div class="left vid-inner-wrap"
         :class="[{ playing: playing }, data.posterPos === 'right' ? 'justify-content-end' : '', data.class]">
      <Transition name="fade">
        <div class="bkg"
             :key="currentVid"
             :style="{ backgroundImage: 'url(' + newImages[currentVid] + ')' }"
        >
        </div>
      </Transition>

      <video
        class="position-absolute absolute-center w-100 vid"
        @play="playing = true"
        @playing="playing = true"
        @pause="playing = false"
        @ended="playing = false"
        ref="vid"
        controls
        v-for="(video, idx) in data.vids"
        v-if="idx === currentVid"
      >
        <source v-for="src in video.src" :src="src" :type="'video/' + src.split('.').pop()">
      </video>

      <div ref="play" class="play-btn" :class="{ 'playing': playing }" @click="playVid()"></div>
    </div>
    <div class="right p-3">
      <h4 class="text-uppercase knockout-50 mw-100 vid-title" :style="{ color: mainColor }"
          v-html="data.selectText"></h4>
      <ul>
        <li
          v-for="(vid, index) in data.vids"
          :key="index"
          :class="{ active: (currentVid === index) }"
          class="position-relative title-item"
        >
          <a href="#" @click.prevent="switchVid(index)" v-html="vid.title"></a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import fscreen from 'fscreen'
  import ContentMixin from '@/components/report/mixins/ContentMixin'

  export default {
    name: 'VidSwitcher',
    mixins: [ ContentMixin ],
    data () {
      return { currentVid: 0, playing: false, newImages: [ '' ] }
    },
    watch: {
      data () { this.setImgs() },

      colorIdx () { this.setImgs() },

      isSmall () { this.setImgs() }
    },
    methods: {
      switchVid ( vid ) {
        this.currentVid = vid
      },
      playVid () {
        this.$refs.vid[ 0 ].play()
        this.playing = true
        if ( this.isMobile ) fscreen.requestFullscreen( this.$refs.vid[ 0 ] )
      },
      setImgs () {
        this.newImages = this.data.vids.map( ( vid ) => {
          let dir = this.isSmall ? '/' : '-desktop/'
          return require( `@/assets/img/posters${dir}${vid.img}_${this.colorIdx + 1}.jpg` )
        } )
      }
    },
    mounted () {
      this.setImgs()
      fscreen.addEventListener( 'fullscreenchange', () => {
        if ( fscreen.fullscreenElement === null ) this.$refs.vid[ 0 ].pause()
      }, false )
    }
  }
</script>

<style lang="scss">
  @import "../../../assets/scss/global/the_goods";

  .vid-switcher {
    position : relative;
    display  : flex;

    @include screen-md {
      width     : 100%;
      max-width : 760px;
      margin    : 0 auto;
    }

    @include screen-lg-xl {
      width     : 100%;
      max-width : 890px;
      margin    : 0 auto;
    }

    .title {
      position        : absolute;
      top             : 0px;
      left            : 0px;
      width           : 100%;
      height          : 100%;
      display         : flex;
      justify-content : center;
      align-items     : flex-start;
      pointer-events  : none;
      z-index         : 10;

      @include screen-md-lg-xl {
        width   : 55%;
        right   : 0;
        left    : auto;
        z-index : 20;
      }

      p {
        background : $white;
        width      : 80vw;
        padding    : 20px;
        transform  : translateY(-50%);
      }
    }

    .vid {
      opacity : 0;

      @include screen-md-lg-xl {
        height : 100%
      }

      .playing & {
        opacity : 1;
      }
    }

    .left,
    .right {
      width           : 50vw;
      height          : 520px;
      display         : flex;
      justify-content : center;
      align-items     : center;
      flex-direction  : column;
      position        : relative;
    }

    .left {

      @include screen-md-lg-xl {
        width   : 75%;
        z-index : 5;

        &.playing {
          .bkg {
            opacity : 0;
          }
        }
      }

      .bkg {
        position            : absolute;
        top                 : 0px;
        left                : 0px;
        width               : 100%;
        height              : 100%;
        background-size     : cover;
        background-position : center;
      }

      .play-btn {
        z-index    : 10;
        opacity    : 1;
        transition : opacity 0.75s;

        &::after {
          left : 52%;

          @include screen-md-lg-xl {
            left : 50.5%;
          }
        }

        &.playing {
          opacity : 0;

          &::after {
            opacity : 0;
          }
        }
      }
    }

    .right {

      @include screen-md-lg-xl {
        width    : 25%;
        position : absolute;
        z-index  : 15;
        right    : 0;
        height   : 90%;
        bottom   : 0;
      }

      h4 {
        text-align     : left;
        font-size      : rem(14);
        padding-top    : 60px;
        letter-spacing : 2px;
      }

      ul {
        margin-left  : 0;
        padding-left : 0;
        text-align   : left;
        list-style   : none;

        li {
          $left-marg : 1rem;
          margin-left : $left-marg;
          padding     : .5rem 0;
          color       : rgba(0, 0, 0, .3);
          font-size   : rem(18);

          &::before {
            content          : '';
            display          : block;
            position         : absolute;
            left             : -$left-marg;
            top              : calc(0.5em + 0.5rem + 1.5px);
            width            : 5px;
            height           : 5px;
            border-radius    : 50%;
            background-color : #bbb;
            border           : none;
          }

          a {
            text-decoration : none;
            transition      : color .3s, border .3s;
            border-bottom   : 1px solid transparent;
            color           : rgba(0, 0, 0, .3);
          }

          &.active {
            a {
              color         : rgba(0, 0, 0, 1);
              border-bottom : 1px solid $black;
            }
          }
        }

      }
    }
  }

  .fade-enter,
  .fade-leave-to {
    opacity : 0;
  }

  .fade-enter-to,
  .fade-leave {
    opacity : 1;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition : opacity .3s;
  }

</style>



// WEBPACK FOOTER //
// src/components/report/content/VidSwitcher.vue